import { Card, CardContent, MetricInfoPopover } from '@/components/ui';
import type { IPortfolioCodeQualityAggregate } from '@skystone/shared';
import { GradeMixChipRow } from './GradeMixChipRow';

interface ReliabilityGradeMixTileProps {
  aggregate: IPortfolioCodeQualityAggregate;
  inScopeRepos: number;
}

/**
 * Verdict-strip tile #3 — Reliability grade mix.
 *
 * Renders A/B/C/D/E + null counts as a colored chip row instead of an
 * invented numeric "score" (D1). The mix is absolute — no delta — chips
 * speak for themselves and a grade-A% trend lives on the Trend column (US4).
 */
export function ReliabilityGradeMixTile({
  aggregate,
  inScopeRepos,
}: Readonly<ReliabilityGradeMixTileProps>) {
  const repoNoun = inScopeRepos === 1 ? 'repo' : 'repos';
  return (
    <Card className="shadow-none" data-testid="cq-reliability-mix-tile">
      <CardContent className="p-4">
        <div className="flex items-center gap-1">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
            Reliability
          </p>
          <MetricInfoPopover metricKey="cq_reliability_rating" />
        </div>
        <div className="mt-3 min-h-[28px]">
          <GradeMixChipRow mix={aggregate.reliabilityGradeMix} />
        </div>
        <p className="mt-2 text-xs text-muted-foreground">
          {inScopeRepos === 0
            ? 'No repos in scope'
            : `Across ${inScopeRepos} ${repoNoun}`}
        </p>
      </CardContent>
    </Card>
  );
}
